export abstract class MainModel {
  id: number = null;
}

export abstract class FilterModel {
  dataManipulation(): void { }
}


export interface MapInterface {
  [key: string]: any;
}
